import moment from 'moment'

const states = {
  apilogs_details: {
    apilogs: [],
    load_more: false,
    selected_filters: {
      isSuccess: false,
      statusCode: "",
      sessionId: "",
      startDate: moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'),
      endDate: moment(new Date(), "DD-MM-YYYY")
    },
    selected_api: {
      id: "",
      response_data: null
    }
  }
}

export default states



// WEBPACK FOOTER //
// ./src/data/redux/apilogs_details/states.js